<div class="container-box review-order-page">
  <div class="success-msg">
    <div class="hide-sm"><i class="icon-controls-approvalL icon-large" aria-hidden="true"> </i>
      <h3> Thank you </h3>
      <p>We're completing your request.</p>
    </div>
    <div class="show-sm"><i class="icon-approval" aria-hidden="true"> </i>
      <h3> Thank you </h3>
      <p>We're completing your request.</p>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12 col-md-12">
      <p class="billto"><span>Order number:</span> {{this.confirmedOrder.orderId}}</p>
      <p class="order-info-label"><span>Bill to:</span> {{billNumber}}</p>
    </div>
  </div>
  <!-- Biil to Section Ends -->
  <div role="order">
  <!--<div role="grid">-->
    <!-- <div class="row"> -->
    <!-- Table Column Start -->
    <div>
      <h2 class="title-columns" role="row"> <span role="columnheader" class="align-left"> Product</span> <span role="columnheader" class="pull-right align-right"> Amount </span>      </h2>
    </div>
    <!-- </div> -->
    <!-- Table Column End -->
    <div class="product-details" *ngFor="let iterateConfirmedOrderLineItems of confirmedOrder.lineItems">
      <hr role="row" class="details-hr" />
      <!-- Workforce Manager Block Starts -->
      <div class="row">
        <!-- Block Wise Iteration Starts -->
        <div class="col-sm-12 col-md-12" role="gridcell">
          <p class="row-headings"> {{iterateConfirmedOrderLineItems?.sku?.displayName}} - {{iterateConfirmedOrderLineItems?.sku?.skuType}} </p>
          <p> <strong>Monthly charges </strong> </p>
        </div>
      </div>
	   <div class="row line-items" role="row" *ngIf="iterateConfirmedOrderLineItems.maxQty > 1">
        <!-- Line Items Iteration Start -->
        <div class="col-sm-6 col-md-6">
          <p><span [innerHTML]="(iterateConfirmedOrderLineItems.quantity > 1)? 'Number of licenses':'Number of license'"></span> {{iterateConfirmedOrderLineItems.quantity}} &#64; {{iterateConfirmedOrderLineItems.sku && iterateConfirmedOrderLineItems.sku.priceInfo.monthlyRecurringFee.amount
            |currency:'USD':true:'1.2-3'}}/user
          </p>
        </div>
        <div class="col-sm-6 col-md-6 text-right" role="coloumn">
         <p class="price-value align-right"> {{iterateConfirmedOrderLineItems?.priceInfo?.monthlyRecurringFee.amount|currency:'USD':true:'1.2-3'}}
          </p>
          <small class="permonth align-right"> per month </small>
        </div>
      </div>
	  <div class="row line-items" role="row" *ngIf="iterateConfirmedOrderLineItems.maxQty == 1" >
        <!-- Line Items Iteration Start -->
        <div class="col-sm-6 col-md-6">
          <!-- <p>{{obj.sku && obj.sku.skuType}} ({{obj.sku && obj.sku.priceInfo.monthlyRecurringFee.amount |currency:'USD':true:'1.2-3'}}/user)-->
          <p role="coloumn">License Price (Unlimited Users)
          </p>
        </div>
        <div class="col-sm-6 col-md-6 text-right" role="coloumn">
         <p class="price-value align-right"> {{iterateConfirmedOrderLineItems?.priceInfo?.monthlyRecurringFee.amount|currency:'USD':true:'1.2-3'}}
          </p>
          <small class="permonth align-right"> per month </small>
        </div>
      </div>
      <div  *ngIf="iterateConfirmedOrderLineItems?.priceInfo?.monthlyRecurringFee?.discountAmount > 0" class="row line-items top-margin">
        <!-- Line Items Iteration Start -->
        <div class="col-sm-6 col-md-6">
          <p class="est-img"> <i class="icon-retail-offers"></i> Estimated discount </p>
        </div>
        <div class="col-sm-6 col-md-6 text-right">
          <p class="price-value align-right"> - {{iterateConfirmedOrderLineItems.priceInfo && iterateConfirmedOrderLineItems?.priceInfo?.monthlyRecurringFee?.discountAmount
            |currency:'USD':true:'1.2-3'}}
          </p>
          <small class="permonth align-right"> per month </small>
        </div>
      </div>
      <!-- Line Items Iteration Ends -->
      <div  class="line-items" *ngFor="let prod of iterateConfirmedOrderLineItems.productConfigurations">
        <!-- Line Items Iteration Start -->

        <div *ngIf="prod.show">
          <p *ngIf="!prod.isDropDown"><span class="label-text">{{prod.label}}:</span> <span class="label-value">{{prod.value}}</span></p>
          <p *ngIf="prod.isDropDown"><span class="label-text">{{prod.label}}:</span> <span class="label-value">{{prod.value.value}}</span> </p>
        </div>
      </div>
      <!-- Line Items Iteration Ends -->
      <!-- One-time Charges Start -->
      <div  class="" *ngIf="iterateConfirmedOrderLineItems.priceInfo && iterateConfirmedOrderLineItems.priceInfo.oneTimeFee.length > 0">
        <div class="row">
          <div class="col-sm-8 col-md-8">
            <p> <strong>One-time charges </strong> </p>
          </div>
        </div>
        <ng-template let-oneTimecharge ngFor [ngForOf]="iterateConfirmedOrderLineItems.priceInfo.oneTimeFee">
          <div class="row otc-line-items">
            <div class="col-sm-6 col-md-6">
              <p class="otc-sub-headings">{{oneTimecharge.oneTimeFeeName}} </p>
            </div>
            <div class="col-sm-6 col-md-3 text-right">
              <p class="price-value" *ngIf="(!oneTimecharge.customPrice) || (oneTimecharge.customPrice === 0)">{{oneTimecharge.unitPrice|currency:'USD':true:'1.2-3'}} </p>
              <p class="price-value" *ngIf="(oneTimecharge.customPrice) && (oneTimecharge.customPrice > 0)">{{oneTimecharge.customPrice|currency:'USD':true:'1.2-3'}} </p>
              <small class="permonth"> one-time payment </small>
            </div>
          </div>
          <div class="row otc-line-items" *ngIf="(iterateConfirmedOrderLineItems.priceInfo.oneTimeFee.length === 1) && (oneTimecharge?.discount > 0)">
            <div class="col-sm-6 col-md-6">
              <p class="otc-sub-headings est-img"> <i class="icon-retail-offers"></i> Estimated discount</p>
            </div>
            <div class="col-sm-6 col-md-3 text-right">
              <p class="price-value"> - {{oneTimecharge.discount|currency:'USD':true:'1.2-3'}}</p>
              <small class="permonth">  one-time payment </small>
            </div>
          </div>
        </ng-template>
        <div *ngIf="(iterateConfirmedOrderLineItems.priceInfo.oneTimeFee.length > 1) && (iterateConfirmedOrderLineItems.priceInfo?.totalOneTimeDiscount > 0)"
          class="row  otc-line-items est-discount">
          <div class="col-sm-6 col-md-6">
            <p class="otc-sub-headings est-img"> <i class="icon-retail-offers"></i> Estimated discount</p>
          </div>
          <div class="col-sm-6 col-md-3 text-right">
            <p class="price-value"> - {{iterateConfirmedOrderLineItems.priceInfo?.totalOneTimeDiscount|currency:'USD':true:'1.2-3'}}</p>
            <small> one-time payment </small>
          </div>
          <div class="clearfix"></div>
      </div>
    </div>
  </div>
  <hr class="top" />
  <div class="product-details" role="row">
    <h2>Total charges*</h2>
    <div class="row total-line-items" >
      <div class="col-sm-7 col-md-6">
        <p> Total monthly charges </p>
      </div>
      <div class="col-sm-5 col-md-6 text-right">
        <p class="total-price align-right">{{this.confirmedOrder.priceInfo && this.confirmedOrder.priceInfo.monthlyRecurringFee.amount |currency:'USD':true:'1.2-3'}}</p>
      </div>
    </div>
    <div class="row total-line-items" >
      <div class="col-sm-7 col-md-6">
        <p> Total one-time charges</p>
      </div>
      <div class="col-sm-5 col-md-3 text-right">
        <p class="total-price align-right"> {{this.confirmedOrder.priceInfo && this.confirmedOrder.priceInfo.oneTimeFee.amount |currency:'USD':true:'1.2-3'}}</p>
      </div>
    </div>
  </div>
</div>
<hr/>
<div class="tnc">
  <p class="last-text">Legal agreement</p>
  <p> {{tnctitle}} is subject to its <a [attr.aria-label]=" tnctitle + 'is subject to its Terms & Conditions (Opens in new window)' "
      href="{{this.confirmedOrder.productTnc}}" target="_blank">Terms & Conditions.</a></p>
  <p> <small>*Totals are based on estimated charges. Taxes and fees will be calculated for applicable charges. Charges will appear on your billing statement. You may not see any discounts or bill credits subtracted from your charges until you select your billing account on the <strong>Checkout</strong> page.</small>    </p>
</div>
<hr class="bot-30" />
<div class="line-footer checkout-area text-right">
  <button type="button" class="btn btn-success btn-checkout" aria-label="Continue shopping" href="javascript:void(0);" (click)="continueshopping()"> Continue shopping </button>
</div>
</div>